import { render, staticRenderFns } from "./ComposeLocalNotSending_4_1.vue?vue&type=template&id=1449c5bd&"
import script from "./ComposeLocalNotSending_4_1.vue?vue&type=script&lang=js&"
export * from "./ComposeLocalNotSending_4_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports